module.exports = __webpack_public_path__ + "static/media/cl_6.6f3c92b6.jpg";